import { GzzTelephone } from '../general/GzzTelephone';
import { GzzAddress } from '../general/GzzAddress';

export class WrsClaimer {

  LastName: string;
  FirstName: string;
  IDNumber: string;
  PhoneNumber: GzzTelephone;
  MobileNumber: GzzTelephone;
  FaxNumber: GzzTelephone;
  Email: string;
  PostAddress: GzzAddress;

  constructor(claimerDetails) {
    
    Object.assign(this, claimerDetails);

    this.PhoneNumber = new GzzTelephone(this.PhoneNumber);
    this.MobileNumber = new GzzTelephone(this.MobileNumber);
    this.FaxNumber = new GzzTelephone(this.FaxNumber);
    this.PostAddress = new GzzAddress(this.PostAddress);
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/worsening/WrsClaimer.ts